import './DocumentsAdministratifs.scss';

import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import useWindowSize from '../../../hooks/useWindowSize';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function NavBarFichExpert() {

    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const [urlPage,setUrlPage]=useState('');
    const { i18n } = useTranslation();
    useEffect(() => {
        console.log('path',pathname);
    });

    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }

    },[pathname]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };

    return (
        <>
            {device=='desktop' ?
                <div
                    className='frame1DocAdmini'
                    style={{flexWrap: 'wrap'}}
                >
                    <div
                        className='frame2DocAdmini'
                        style={{flexWrap: 'wrap'}}
                    >
                        <div
                            className='frame10DocAdmini'
                            style={{flexWrap: 'wrap'}}
                        >
                            <div
                                className='frame3DocAdmini'
                                style={
                                    currentPath == 'PieceIdentite' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'PieceIdentite' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'PieceIdentite')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PieceIdentite', { replace: true });
                                    }}
                                >{i18n.t('Pièce d\'identité')}</p>
                            </div>

                            <div
                                className='frame5DocAdmini'
                                style={
                                    currentPath == 'Kbis' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'Kbis' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'Kbis')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Kbis', { replace: true });

                                    }}

                                >Kbis</p>
                            </div>

                            <div
                                className='frame6DocAdmini'
                                style={
                                    currentPath == 'AttestationUrsaf' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'AttestationUrsaf' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'AttestationUrsaf')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationUrsaf', { replace: true });

                                    }}

                                >{i18n.t('Attestation Urssaf')}</p>
                            </div>

                            <div
                                className='frame7DocAdmini'
                                style={
                                    currentPath == 'Assurance' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'Assurance' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'Assurance')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Assurance', { replace: true });

                                    }}

                                >{i18n.t('Assurance')}</p>
                            </div>

                            <div
                                className='frame9DocAdmini'
                                style={
                                    currentPath == 'AttestationFiscale' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >

                                <p
                                    style={
                                        currentPath == 'AttestationFiscale' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'AttestationFiscale')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationFiscale', { replace: true });

                                    }}

                                >{i18n.t('Attestation fiscale')}</p>
                            </div>

                            <div
                                className='frame4DocAdmini'
                                style={
                                    currentPath == 'Contrat' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }

                            >
                                <p
                                    style={
                                        currentPath == 'Contrat' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'Contrat')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Contrat', { replace: true });

                                    }}

                                >{i18n.t('Contrat')}</p>
                            </div>

                            <div
                                className='frame8DocAdmini'
                                style={
                                    currentPath == 'AttestationHonneur' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'AttestationHonneur' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'AttestationHonneur')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationHonneur', { replace: true });
                                    }}

                                >{i18n.t('Attestation sur l\'honneur')}</p>
                            </div>
                        </div>

                    </div>
                </div>
                :
                <>
                    <div style={{width:'100%',minWidth:'200px',maxWidth:'500px'}}>
                        <SelectComponent
                            val={urlPage}
                            setVal={(e) => handleChangeUrl(e)}
                            listVal={[
                                {
                                    value: '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PieceIdentite',
                                    label: i18n.t('Pièce d\'identité')
                                },
                                {
                                    value: '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/kbis',
                                    label: i18n.t('Kbis')
                                },

                                {
                                    value: '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationUrsaf',
                                    label: i18n.t('Attestation Urssaf')
                                },

                                {
                                    value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Assurance',
                                    label: i18n.t('Assurance')
                                },
                                {
                                    value: '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationFiscale',
                                    label: i18n.t('Attestation fiscale')
                                },
                                {
                                    value: '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Contrat',
                                    label: i18n.t('Contrat')
                                },
                                {
                                    value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationHonneur',
                                    label: i18n.t('Attestation sur l\'honneur')
                                }
                            ]}
                        />
                    </div>
                </>
            }
        </>

    );
}

export default NavBarFichExpert;